import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TotalsResponse } from '../models/totals-response.model';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class StatisticsService {
    private readonly baseUrl = `${environment.http.apiRoot}/data`;

    constructor(private http: HttpClient) { }

    getTotals(): Observable<TotalsResponse> {
        return this.http.get<TotalsResponse>(`${this.baseUrl}/totals`);
    }
}
